module.exports = __webpack_public_path__ + "static/media/Global_Recycled_Standard.5bdc76c2.svg";